webpackJsonp([0],{

/***/ "/wzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"portfolio"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Qci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "SidebarItem",
	props: ["name", "iconClass", "targetId", "scrollToSpeed"],
	directives: {
		scrollTo: __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a
	},
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "12gL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerSection_vue__ = __webpack_require__("pM2U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f45081_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerSection_vue__ = __webpack_require__("g2ym");
function injectStyle (ssrContext) {
  __webpack_require__("t81F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44f45081"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f45081_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footerSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2o2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('i',{staticClass:"sidebar_nav_icon fa fa-fw",class:_vm.iconClass,attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
			el: _vm.targetId,
			duration: _vm.scrollToSpeed,
			easing: 'ease-in-out'
	}),expression:"{\n\t\t\tel: targetId,\n\t\t\tduration: scrollToSpeed,\n\t\t\teasing: 'ease-in-out'\n\t}"}],staticClass:"nostyle",attrs:{"href":"#"}},[_c('span',{staticClass:"sidebar_item_name"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "39ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({ name: "portfolio" });

/***/ }),

/***/ "4ila":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"experiences_section"}},[_c('div',{staticClass:"flex_container centered_horizontally"},[_c('div',{staticClass:"section_content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('section',{staticClass:"expertise_list"},_vm._l((_vm.experiences),function(experience){return _c('div',{key:experience.title,staticClass:"expertise"},[_c('h2',[_vm._v(_vm._s(experience.title))]),_vm._v(" "),_vm._l((experience.examples),function(example){return _c('p',{key:example},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(example)+"\n\t\t\t\t\t")])})],2)}),0),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('section',[_c('div',{staticClass:"company_list_container"},[_c('ul',{staticClass:"company_list"},_vm._l((_vm.internships),function(internship){return _c('li',{key:internship.url,style:({
								backgroundImage: internship.backgroundImage,
								backgroundColor: internship.backgroundColor
							})},[_c('a',{attrs:{"href":internship.url}},[_c('div',[_c('img',{attrs:{"src":internship.img,"alt":""}})])])])}),0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"section_title_container"},[_c('span',{staticClass:"section_title"},[_vm._v("Experiences")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section_subtitle_container"},[_c('span',{staticClass:"section_subtitle"},[_vm._v("Expertise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section_subtitle_container"},[_c('span',{staticClass:"section_subtitle"},[_vm._v("Internships")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ARjF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CEmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebarItem_vue__ = __webpack_require__("0Qci");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d15a0f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebarItem_vue__ = __webpack_require__("2o2m");
function injectStyle (ssrContext) {
  __webpack_require__("hOmA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d15a0f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d15a0f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EVsW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EkYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"title_section"}},[_c('div',{staticClass:"section_content"},[_c('div',{attrs:{"id":"title_container"}},[_c('h1',{staticClass:"my_name no_text_select"},[_vm._v("Daniel-Junior Dubé")]),_vm._v(" "),_c('h2',{staticClass:"under_my_name no_text_select"},[_vm._v("Portfolio")]),_vm._v(" "),_c('div',{staticClass:"title_social_media_links no_text_select"},[_c('hr'),_vm._v(" "),_c('ul',[_vm._l((_vm.socialMediaLinks),function(socialMediaLink){return _c('li',{key:socialMediaLink.url},[_c('a',{attrs:{"href":socialMediaLink.url}},[_c('i',{class:socialMediaLink.class,style:({color: socialMediaLink.color}),attrs:{"aria-hidden":"true"}})])])}),_vm._v(" "),_vm._m(0)],2)])])]),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
			el: '#experiences_section',
			duration: _vm.scrollToSpeed,
			easing: 'ease-in-out'
	}),expression:"{\n\t\t\tel: '#experiences_section',\n\t\t\tduration: scrollToSpeed,\n\t\t\teasing: 'ease-in-out'\n\t}"}],staticClass:"scrollto_next",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-2x fa-angle-double-down",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://drive.google.com/file/d/1yqZrAZvo4KqFtTkEdqbPMkevAYBQAI6r/view?usp=sharing"}},[_c('span',[_vm._v("Curriculum Vitae")]),_vm._v(" "),_c('i',{staticClass:"fas fa-file-pdf"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FB68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar',{attrs:{"scroll-to-speed":"750"}}),_vm._v(" "),_c('title-section',{attrs:{"scroll-to-speed":"750"}}),_vm._v(" "),_c('experiences-section'),_vm._v(" "),_c('footer-section')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LQcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("blXB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8f4c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FB68");
function injectStyle (ssrContext) {
  __webpack_require__("g1ze")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8f4c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NFMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_titleSection_vue__ = __webpack_require__("eEgD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50026f7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_titleSection_vue__ = __webpack_require__("EkYj");
function injectStyle (ssrContext) {
  __webpack_require__("ARjF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50026f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_titleSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50026f7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_titleSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */] }
});

/***/ }),

/***/ "SOJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YJXf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingPage_index__ = __webpack_require__("LQcU");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'Landing page',
		component: __WEBPACK_IMPORTED_MODULE_2__components_landingPage_index__["a" /* default */]
	}]
}));

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("39ur");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a62a5f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("/wzU");
function injectStyle (ssrContext) {
  __webpack_require__("EVsW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a62a5f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aj/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebarItem__ = __webpack_require__("CEmp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Sidebar",
	props: ["scrollToSpeed"],
	components: {
		SidebarItem: __WEBPACK_IMPORTED_MODULE_0__sidebarItem__["a" /* default */]
	},
	data: function data() {
		return {
			items: [{
				name: "Landing",
				targetId: "#title_section",
				iconClass: "fas fa-user-circle"
			}, {
				name: "Experiences",
				targetId: "#experiences_section",
				iconClass: "fa-briefcase"
			}]
		};
	}
});

/***/ }),

/***/ "blXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_sidebar__ = __webpack_require__("ivsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landingPage_titleSection__ = __webpack_require__("NFMd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__landingPage_experiencesSection__ = __webpack_require__("osH0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__landingPage_footerSection__ = __webpack_require__("12gL");
//
//
//
//
//
//
//
//
//
//





//import ProjectsSection from '../landingPage/projectsSection'
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "LandingPage",
	components: {
		Sidebar: __WEBPACK_IMPORTED_MODULE_0__sidebar_sidebar__["a" /* default */],
		TitleSection: __WEBPACK_IMPORTED_MODULE_1__landingPage_titleSection__["a" /* default */],
		ExperiencesSection: __WEBPACK_IMPORTED_MODULE_2__landingPage_experiencesSection__["a" /* default */],
		FooterSection: __WEBPACK_IMPORTED_MODULE_3__landingPage_footerSection__["a" /* default */]
		//ProjectsSection,
	}
});

/***/ }),

/***/ "eEgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "LandingPageTitleSection",
	props: ["scrollToSpeed"],
	data: function data() {
		return {
			socialMediaLinks: [{ url: 'https://twitter.com/HEYIMFUZZ', class: "fab fa-twitter", color: "#55acee" }, { url: 'https://github.com/daniel-junior-dube', class: "fab fa-github", color: "#fff" }, { url: 'https://www.facebook.com/junior.dube.5', class: "fab fa-facebook", color: "#3B5998" }, { url: 'https://www.linkedin.com/in/daniel-junior-dubé-418a3381', class: "fab fa-linkedin", color: "#0077b5" }]
		};
	},

	directives: {
		scrollTo: __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a
	}
});

/***/ }),

/***/ "g1ze":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g2ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"footer"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hOmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivsI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("aj/V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c95abb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("vMMI");
function injectStyle (ssrContext) {
  __webpack_require__("SOJt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c95abb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c95abb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oS00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "LandingPageExperiencesSection",
	data: function data() {
		return {
			experiences: [{
				title: "Web Development",
				examples: ["Internships in Full-Stack Development", "Node.js, Ruby on Rails, Python and PHP", "Dev-Ops"]
			}, {
				title: "Mobile Development",
				examples: ["Android Apps With Java and Socket.io", "Cross Platform Application With React Native"]
			}, {
				title: "Native Development",
				examples: ["Implemented OS features in NachOS", "Projects in 6502 Micro-Processor and Spark assembly", "OpenGL Applications"]
			}],
			internships: [{
				url: "https://www.boreal-is.com/fr/",
				img: "/static/images/borealis_md.png",
				backgroundImage: "url(/static/images/borealis_bg.jpg)",
				backgroundColor: "black"
			}, {
				url: "https://www.rtings.com/",
				img: "/static/images/rtings_md.png",
				backgroundImage: "url(/static/images/rtings_bg.jpg)",
				backgroundColor: "black"
			}, {
				url: "https://www.metareal.com/",
				img: "/static/images/metareal_md.png",
				backgroundImage: "url(/static/images/metareal_bg.jpg)",
				backgroundColor: "black"
			}, {
				url: "https://www.mirego.com/",
				img: "/static/images/mirego_md.png",
				backgroundImage: "",
				backgroundColor: "black"
			}]
		};
	}
});

/***/ }),

/***/ "osH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_experiencesSection_vue__ = __webpack_require__("oS00");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be7f813_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_experiencesSection_vue__ = __webpack_require__("4ila");
function injectStyle (ssrContext) {
  __webpack_require__("YJXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0be7f813"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_experiencesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be7f813_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_experiencesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pM2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "LandingPageFooterSection",
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "t81F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vMMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"sidebarItemList"},_vm._l((_vm.items),function(item){return _c('sidebar-item',{key:item.name,attrs:{"name":item.name,"target-id":item.targetId,"icon-class":item.iconClass,"scroll-to-speed":_vm.scrollToSpeed}})}),1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nostyle logo",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/images/block_sm.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nostyle mail_to",attrs:{"href":"mailto:daniel.junior.dube@gmail.com"}},[_c('i',{staticClass:"fas fa-fw fa-envelope",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.df4e2c81082d55fc829e.js